export class AuditUser{
    public AuditID:number = -1;
    public UserID:number = -1;
    public DisplayName:string = "";
    public HasPermission:boolean = false;
    public Username:string = "";
    public Email:string = "";
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}